module.exports = __webpack_public_path__ + "img/hands.82bdd44d.png";